import React from "react"
import "../assets/css/ui-kit.css"
import "../assets/css/global.css"
import "../assets/css/style-guide.css"
import "../assets/css/global-responsive.css"
import { ToastProvider } from "react-toast-notifications"
import LanguageContextProvider from "../context"
import {CookieNotice} from "gatsby-cookie-notice";

export default function Layout({ className, path, children, langcode, translationPaths }) {
  return (
      <LanguageContextProvider
        langcode={langcode}
        translationPaths={translationPaths}
      >
      <div style={{ margin: `0 auto` }} className={className}>
      <ToastProvider>
        {children}
      </ToastProvider>
      <CookieNotice
         personalizeButtonText={"Vull triar les meves cookies !"}
         acceptButtonText={"Acceptar cookies"}
         declineButtonText={"Rebutjar"}
         personalizeButtonText={"Personalitzar"}
         personalizeValidationText={"Guardar"}
         cookies={[
                 {name: 'necessary', editable: false, default: true, title: 'Essencial', text: 'Les cookies essencials són necessàries per al bon funcionament del lloc. El lloc no pot funcionar correctament sense ells.' },
                 {name: 'gatsby-gdpr-google-analytics', editable: true, default: true, title: 'Google Analytics', text: 'Google Analytics és una eina estadística de Google que permet mesurar l\'audiència del lloc web.' }
           ]}
          >

          <h4>Aquest lloc web utilitza cookies.</h4>
          <p>Utilitzem cookies per fer que el lloc funcioni millor, però també per veure com interactueu amb ell. Només utilitzarem cookies si ens ho permets fent clic a "Acceptar cookies". També podeu triar quina galeta voleu permetre.</p>
      </CookieNotice>
      </div>
      </LanguageContextProvider>
  )
}
